<div [style]="'display: flex; justify-content: center'">
  <i nz-icon nzType="loading-3-quarters" nzSpin [style]="'font-size: 40px'"></i>
</div>
